import { render, staticRenderFns } from "./calendarJobCall.vue?vue&type=template&id=1636afc4&scoped=true"
import script from "./calendarJobCall.vue?vue&type=script&lang=js"
export * from "./calendarJobCall.vue?vue&type=script&lang=js"
import style0 from "./calendarJobCall.vue?vue&type=style&index=0&id=1636afc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1636afc4",
  null
  
)

export default component.exports